import { render, staticRenderFns } from "./BrandQueryResultView.vue?vue&type=template&id=f4768a3e&scoped=true&"
import script from "./BrandQueryResultView.vue?vue&type=script&lang=ts&"
export * from "./BrandQueryResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4768a3e",
  null
  
)

export default component.exports